export const eventsRoute: string = "events";
export const sessionsRoute: string = "sessions";
export const recordingsRoute: string = "recordings";
export const eventRegisterRoute: string = "attendee/register";
export const eventRegistrationDetailsRoute: string = "registration";
export const meRoute: string = "me";
export const pageViewCountRoute: string = "metrics/pageviewcount";
